import { frontendURL } from '../../../helper/URLHelper';
import CriarImovelIndex from './pages/CriarImovelIndex.vue';
import { LAIS_IMOVEIS_PERMISSIONS } from '../laisRouteHelpers';

const meta = { permissions: LAIS_IMOVEIS_PERMISSIONS };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/criar-imovel'),
    alias: [frontendURL('accounts/:accountId/criar')],
    name: 'lais_criar_imovel_index',
    component: CriarImovelIndex,
    meta,
  },
];
